import { Button, Col, Row, Table } from 'antd';
import React, { useEffect, useState } from 'react'
import { API_ROUTE } from '../../../utils/commonConstants';
import { GET } from '../../../utils/requestActionConstants';
import { fetcher } from '../../../helpers/processRequest';
import useSWR from 'swr';
import { userTabConfig } from '../UsersTab';
import { useDispatch, useSelector } from 'react-redux';
import { setUsers, setUser } from '../../../store/slices/userSlice';
import SearchComponent from '../../../components/SearchComponent';


function UserList({onSwitchTab}) {
    const dataFetcher = useSWR({method: GET, url: API_ROUTE + '/users'} , fetcher);
    const state = useSelector(state => state.userSlice);
    const dispatch = useDispatch();
    const [filteredData, setFilteredData] = useState([]);

    const edit = (data) => {
        dispatch(setUser(data))
        onSwitchTab(userTabConfig.ADD, data);
    }
    
    useEffect(() => {
      if (dataFetcher.data?.data) {
        dispatch(setUsers(dataFetcher.data.data));
      }
    }, [dataFetcher.data?.data])

    const columns = [
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
          filterSearch: true
        },
        {
          title: 'Email',
          dataIndex: 'email',
          key: 'email',
          filterSearch: true
        },
        {
          title: 'Role',
          dataIndex: 'role',
          key: 'role',
          filterSearch: true
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <>
                    <div>
                        <Button onClick={() => edit(record)}>Amend</Button>
                    </div>
                </>
            )
        }
      ];
    
      const onFilter = (filteredData) => {
        setFilteredData(filteredData);
      }
    
      return (
        <Row gutter={[16, 16]}>
          <SearchComponent masterData={state.userList} onFilter={onFilter} filterByKeys={['name', 'email', 'role']} />
          <Col span={24} className='overflow-x-auto'>
            <Table columns={columns} dataSource={filteredData} pagination={false} loading={dataFetcher.isLoading} />
          </Col>
        </Row>
      );
}

export default UserList